import FullBg from '../../commonSub/component/FullBg';

interface IProps {
  bgColor?: string;
  lineColor: string;
}

export default function CommentDivider({bgColor, lineColor}: IProps) {
  return (
    <FullBg className="z-1" bgClassName={bgColor}>
      <div className={cn('w-full h-1', lineColor)} />
    </FullBg>
  );
}
